import { PAYMENT_STATE } from './paymentState';

export const PAYMENT_STATE_LABELS: Record<PAYMENT_STATE, string> = {
  [PAYMENT_STATE.PAYMENT_PENDING]: 'Pago pendiente',
  [PAYMENT_STATE.PENDING_SIGNATURE]: 'Firma pendiente',
  [PAYMENT_STATE.APPROVED]: 'Aprobado',
  [PAYMENT_STATE.REJECTED]: 'Rechazado',
  [PAYMENT_STATE.DELIVERED]: 'Entregado',
  [PAYMENT_STATE.DOCUMENTATION_CONTROL]: 'Control de documentación',
  [PAYMENT_STATE.PENDING_DOCUMENTATION]: 'Documentación pendiente',
  [PAYMENT_STATE.CONTROLLED_DOCUMENTATION]: 'Documentación controlada',
  [PAYMENT_STATE.REFUNDED]: 'Reembolsado',
  [PAYMENT_STATE.PARTIALREFUND]: 'Reembolso parcial',
  [PAYMENT_STATE.REVISION]: 'Revisión',
};

export const PAYMENT_STATE_LABELS_ES: Record<string, string> = {
  Pending: 'Pendiente',
  Simulation: 'Simulación',
  Approved: 'Aprobado',
  Revision: 'Revisión',
  Rejected: 'Rechazado',
  'No Funds': 'Fondos insuficientes',
  'Manual Revision': 'Revisión manual',
  'Charge Back': 'Contracargo',
  Failed: 'Fallido',
  'Pre Approved': 'Pre-aprobado',
  Cancelled: 'Cancelado',
  Refunded: 'Reembolsado',
  Abandoned: 'Abandonado',
  'CS Yellow': 'Atención cliente (amarillo)',
  'CS Red': 'Atención cliente (rojo)',
  'CS Other': 'Atención cliente (otro)',
  Recovered: 'Recuperado',
  Duplicated: 'Duplicado',
  'Not Interested': 'No interesado',
  'Payment link': 'Link de pago',
  'Internal Rejection': 'Rechazo interno',
  PartialRefund: 'Reembolso parcial',
};
